
const type = transaction => ({
  deposit: !!transaction.deposit,
  bonus: !!transaction.bonusFromRefer || !!transaction.bonusFromSignIn || !!transaction.bonus,
})

export {
  type
}
